export const subscriptionAction = (data) => async dispatch => {
   
    dispatch( {
        type: "SUBSCRIPTION",
        payload: data
    })
}